module.exports = __webpack_public_path__ + "img/关于.bbdba2ef.png";